import CallIcon from '@mui/icons-material/Call';
import { IconButton } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { MdCallEnd } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { useBans } from '../../../../../../hooks/useBans';
import { setCallState } from '../../../../../../reduxToolkit/slices/commonSlice';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';
import { CALLINGSTATE } from '../../../../../../utils/enums';
import VyTooltip from '../../../../../common/VyTooltip';

export interface AttendeeCallButtonProps {
  calleeId: string;
  name: string;
}

export const AttendeeCallButton = (props: AttendeeCallButtonProps) => {
  const { calleeId, name } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isBannedFromMessaging } = useBans();

  const callState = useSelector(({ common }) => common.callState);
  const messaging = useSelector(({ common }) => common.attendeeMessaging);
  const userbans = useSelector(({ common }) => common.userbans);
  const user = useSelector(({ common }) => common.user);

  const isReported = messaging?.reporters?.includes(user!._id) ?? false;
  const isBanned = userbans ? isBannedFromMessaging(userbans) : false;
  const canCall = !isReported && !isBanned;

  function handleClick() {
    dispatch(
      setCallState({
        current: CALLINGSTATE.CALLING,
        calleeId: calleeId,
        calleeName: name,
        showModal: true,
        participants: [],
        camActive: true,
        micActive: true,
      })
    );
  }

  return (
    <>
      {callState.current === CALLINGSTATE.IDLE ? (
        <VyTooltip title={t(canCall ? 'meeting:on-site-call.start-call' : 'meeting:on-site-call.banned', { name: name })}>
          <IconButton onClick={handleClick} size="large" disabled={!canCall}>
            <CallIcon />
          </IconButton>
        </VyTooltip>
      ) : (
        <VyTooltip title={t('meeting:on-site-call.call-ongoing')}>
          <IconButton disabled size="large">
            <MdCallEnd />
          </IconButton>
        </VyTooltip>
      )}
    </>
  );
};
